<div *transloco="let t">
  @if (emptyDspAudiences()) {
    <div class="text-sm text-gray-500">
      {{
        audienceType() === DspStrategyDspAudienceType.WHITELIST
          ? t("dsp-audiences-selector.no_audience")
          : t("dsp-audiences-selector.no_audience_blacklist")
      }}
    </div>
  } @else {
    @for (audienceGroup of dspAudiences(); track audienceGroup; let groupIndex = $index; let first = $first) {
      <div class="mt-2 flex flex-col">
        @if (audienceType() === DspStrategyDspAudienceType.WHITELIST) {
          @if (!first) {
            <IBadge [label]="t('common.and') | titlecase" color="gray" class="my-4" />
          }
          <div class="rounded-md border" [ngClass]="{ 'border-b-0': audienceGroup.length > 1 }">
            <div class="flex justify-between border-b p-2 text-sm font-medium text-gray-700">
              <span>{{
                first
                  ? t("dsp-audiences-selector.target_people_matching")
                  : t("dsp-audiences-selector.and_must_also_match")
              }}</span>
            </div>
            <div class="relative">
              <div class="relative min-h-24">
                @for (audience of audienceGroup; track audience.audienceId; let audienceIndex = $index) {
                  <app-dsp-audience-line
                    [audience]="audience"
                    [isInAudienceGroup]="true"
                    [isLastInGroup]="audienceIndex === audienceGroup.length - 1"
                    [isReadOnly]="true"
                    [drawBottomBorder]="audienceIndex < audienceGroup.length"
                    [displayFee]="false"
                  >
                  </app-dsp-audience-line>
                }
              </div>
            </div>
          </div>
        } @else {
          <div class="rounded-md border">
            @for (audience of audienceGroup; track audience.audienceId; let last = $last) {
              <app-dsp-audience-line
                [audience]="audience"
                [isInAudienceGroup]="true"
                [isLastInGroup]="last"
                [excluded]="true"
                [operator]="'and'"
                [isReadOnly]="true"
                [drawBottomBorder]="!last"
                [displayFee]="false"
              >
              </app-dsp-audience-line>
            }
          </div>
        }
      </div>
    }
  }
</div>
